import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_DUE_DATE_LIST } from '../urls'
import ManthlyDueDateForm from './ManthlyDueDateForm'

export default function ManthlyDueDateCreate({ onCancel, onSuccess, dueId }) {
    const rotationCreate = usePostRequest({ url: MANTHLY_DUE_DATE_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data: { ...data, due: dueId } })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyDueDateForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
